"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tagSizes = exports.tagVariants = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const tag_module_scss_1 = __importDefault(require("./tag.module.scss"));
exports.tagVariants = ['primary', 'secondary', 'success', 'info'];
exports.tagSizes = ['small', 'medium'];
const Tag = (_a) => {
    var { variant = 'primary', size = 'medium', icon, children, width } = _a, props = __rest(_a, ["variant", "size", "icon", "children", "width"]);
    const withIcon = !!icon;
    const content = withIcon ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [icon, (0, jsx_runtime_1.jsx)("span", { children: children })] })) : (children);
    return ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: (0, classnames_1.default)(tag_module_scss_1.default.tag, tag_module_scss_1.default[`variant_${variant}`], tag_module_scss_1.default[`size_${size}`], withIcon && tag_module_scss_1.default.withIcon), style: width ? { width } : undefined }, props, { children: content })));
};
exports.default = Tag;
